import { useState } from 'react';
import { FileUpload, Input, Button, Alert } from '@dreamtree-org/twreact-ui';
import { uploadFile } from '@/lib/uploads';

const ACCEPT = 'image/jpeg,image/png,image/webp';

/**
 * An image on the landing page: upload (attached to the draft, served publicly),
 * preview, alt text, remove. Value is { media_id, alt } or null.
 */
export default function ImageField({ label, value, onChange, draftId, kind = 'storefront', alt = true, error }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const upload = async (files) => {
    const file = files && files[0];
    if (!file) return;
    setErr('');
    setBusy(true);
    try {
      const r = await uploadFile(file, { ownerType: 'storefront', ownerId: draftId, kind });
      onChange({ media_id: r.media_id, alt: (value && value.alt) || '' });
    } catch (ex) {
      setErr(ex.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-2">
      <div className="text-sm font-medium">{label}</div>
      {value && value.media_id != null ? (
        <div className="flex items-start gap-3">
          <img src={`/api/public-media/${value.media_id}`} alt="" className="h-20 w-32 rounded-md border border-[var(--app-border)] object-cover" />
          <div className="flex-1 space-y-2">
            {alt ? <Input label="Alt text (describe the image)" value={value.alt || ''} maxLength={120} onChange={(e) => onChange({ ...value, alt: e.target.value })} /> : null}
            <Button size="sm" variant="outline" onClick={() => onChange(null)}>Remove image</Button>
          </div>
        </div>
      ) : (
        <FileUpload accept={ACCEPT} maxSize={8 * 1024 * 1024} onFileSelect={upload} disabled={busy || !draftId} />
      )}
      {busy ? <p className="text-xs opacity-70">Uploading…</p> : null}
      {err || error ? <Alert variant="error">{err || error}</Alert> : null}
    </div>
  );
}
